export const GAMEMODE_PARAMETER_PRESETS = ["gameMode", "universeId", "queueId"] as const

export type GamemodeParameterPreset = (typeof GAMEMODE_PARAMETER_PRESETS)[number]

export const isPresetGamemodeParameter = (value: string): boolean => GAMEMODE_PARAMETER_PRESETS.includes(value as GamemodeParameterPreset)
